<template>
    <ai-form-number-box-readonly
        :meta='meta.metaKod'
        :server-data='userData'
        :class="`size-${meta.metaKod.size[0]}-${meta.metaKod.size[1]}`"
    ></ai-form-number-box-readonly>
    <tep-tarif-search
        :meta='meta.metaName'
        :callbacks='{userDataChanged: dataChanged}'
        :class="`size-${meta.metaName.size[0]}-${meta.metaName.size[1]}`"
    />
    <ai-form-number-box-readonly
        :meta='meta.metaRate'
        :server-data='userData'
        :class="`size-${meta.metaRate.size[0]}-${meta.metaRate.size[1]}`"
    ></ai-form-number-box-readonly>
</template>
<script>
export default {
    name: 'tep-tarif'
};
</script>
<script setup>
import { inject } from 'vue';
import TepTarifSearch from '@/views/tep/tep-grid/components/tep-tarif-search.vue';
import AiFormNumberBoxReadonly from '@/components/card-component/ai-form-number-box-readonly.vue';

// eslint-disable-next-line no-unused-vars
const props = defineProps({
    meta: {
        type: Object,
        default: () => {}
    },
    callbacks: {
        type: Object,
        default: () => ({ userDataChanged: null }),
    },
});

const userData = inject('userData');

const dataChanged = (data) => {
    if (data.ratesData.length > 0)
        userData.value[props.meta.metaRate.fieldNameText] = data.ratesData[0][props.meta.metaRate.fieldValue];
    userData.value[props.meta.metaKod.fieldNameText] = data.tarifData[props.meta.metaKod.fieldValue];
    if (props.callbacks.userDataChanged) props.callbacks.userDataChanged();
}
</script>
<style scoped></style>
